import React, { HTMLAttributes } from "react"
import styled from "styled-components"
import cn from "clsx"

const CaptionTypography = styled.p`
  font-family: "Inter";
  font-style: normal;

  &.size-large {
    font-size: 12px;
    line-height: 16px;
  }

  &.size-medium {
    font-size: 10px;
    line-height: 14px;
  }

  &.size-small {
    font-size: 8px;
    line-height: 10px;
  }

  &.color-success {
    color: ${(props) => props.theme.palette.success};
  }

  &.color-alert {
    color: ${(props) => props.theme.palette.informative};
  }

  &.color-error {
    color: ${(props) => props.theme.palette.error};
  }

  &.color-primary-dark {
    color: ${(props) => props.theme.palette.primary_one};
  }

  &.color-primary_alt_medium {
    color: ${(props) => props.theme.palette.secondary_three};
  }

  &.color-primary-alt-soft {
    color: ${(props) => props.theme.palette.secondary_four};
  }

  &.color-secondary-medium {
    color: ${(props) => props.theme.palette.secondary_medium};
  }

  &.color-secondary-dark {
    color: ${(props) => props.theme.palette.secondary_dark};
  }

  &.color-gray-dark {
    color: ${(props) => props.theme.palette.text};
  }

  &.color-gray-medium {
    color: ${(props) => props.theme.palette.subtitle};
  }

  &.color-gray-light {
    color: ${(props) => props.theme.palette.disabled};
  }

  &.color-black {
    color: ${(props) => props.theme.palette.black};
  }

  &.color-white {
    color: ${(props) => props.theme.palette.white};
  }

  &.weight-light {
    font-weight: 400;
  }

  &.weight-regular {
    font-weight: 500;
  }

  &.weight-semi-bold {
    font-weight: 600;
  }

  &.weight-bold {
    font-weight: 700;
  }

  &.link {
    text-decoration-line: underline;
  }

  &.disabled {
    color: ${(props) => props.theme.palette.gray_light} !important;
    cursor: not-allowed;
  }
`

export interface CaptionProps extends HTMLAttributes<HTMLDivElement> {
  size: "small" | "medium" | "large"
  color:
    | "success"
    | "alert"
    | "error"
    | "primary-dark"
    | "primary-alt-soft"
    | "secondary-medium"
    | "secondary-dark"
    | "gray-dark"
    | "gray-medium"
    | "gray-light"
    | "black"
    | "white"
  weight?: "light" | "regular" | "semi-bold" | "bold"
  link?: boolean
  disabled?: boolean
  className?: string
}

const Caption = (props: CaptionProps) => {
  const { size, color, weight = "light", link = false, disabled = false, className, ...rest } = props

  return (
    <CaptionTypography
      className={cn(`size-${size}`, `color-${color}`, `weight-${weight}`, { link, disabled }, className)}
      {...rest}
    />
  )
}

export default Caption
